import {
  Box,
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import Page from 'src/components/Page';
import RFPService from 'src/services/rfp/rfp.service';
import { getRfpByUserStart } from "../../../store/products/actions";
import data from './data';
import ProductCard from './ProductCard';
import Toolbar from './Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  productCard: {
    height: '100%'
  }
}));

const ProductList = ({ match, getRfpByUserStart, productData }) => {
  const classes = useStyles();
  const [products, setRfpState] = useState(data);
  const [productCopy, setRfpCopyState] = useState(data);
  const [sortOrderStatus, sortOrderStatusState] = useState(false);
  const [filterVal, filterValState] = useState("select");

  const rfpService = new RFPService();
  const autoClose = false;
  const keepAfterRouteChange = true;
  const isNewUser = match.params.isFirstLogin;
  if (isNewUser == "true") {
    // alertService.success("Welcome on Requestly, please create RFP or add company information", { autoClose, keepAfterRouteChange })
  }

  // console.log(match, "props....");

  const filterRfp = (e) => {
    const products = [...productCopy];
    switch (e.target.value) {
      case 'completed':
        let filteredResult = products.filter((product) => {
          return new Date(product.rfpTimeline) <= new Date();
        })
        setRfpState(filteredResult);
        break;
      case 'inprogress':
        let filteredProducts = products.filter((product) => {
          return new Date(product.rfpTimeline) >= new Date();
        })
        setRfpState(filteredProducts);
        break;
      case 'all':
        setRfpState(products);
        break;
      default:
        setRfpState(products);
        break;
    }
  }

  const sortRfp = (value) => {
    filterValState(value);
    switch (value) {
      case 'title':
        let productCopy = [...products];
        productCopy.sort(function (a, b) {
          // console.log(a.rfpName, b.rfpName, "rfpNames")
          if (!sortOrderStatus) {
            return a.rfpName.toLowerCase() < b.rfpName.toLowerCase() ? 1 : -1;
          }
          else {
            return a.rfpName.toLowerCase() > b.rfpName.toLowerCase() ? 1 : -1;
          }
        });
        setRfpState(productCopy);
        break;
      case 'createddate':
        let productsCopy = [...products];
        // alert(sortOrderStatus);
        productsCopy.sort(function (a, b) {
          if (!sortOrderStatus) {
            return new Date(a.createdAt) < new Date(b.createdAt) ? 1 : -1
          }

          else {
            // if (new Date(a.createdAt) > new Date(b.createdAt)) { return 1; }
            return new Date(a.createdAt) > new Date(b.createdAt) ? 1 : -1
          }

        })
        setRfpState(productsCopy);
        //setRfpCopyState(productsCopy);
        break;
      case 'publishdate':
        let productCopy2 = [...products];
        productCopy2.sort(function (a, b) {
          if (!sortOrderStatus) {
            return new Date(a.rfpPublishedDate) < new Date(b.rfpPublishedDate) ? 1 : -1;
          } else {
            return new Date(a.rfpPublishedDate) > new Date(b.rfpPublishedDate) ? 1 : -1;
          }
        })
        setRfpState(productCopy2);
        break;
      default:
        setRfpState(products);
        break;
    }

  }

  useEffect(() => {
    sortRfp(filterVal);
  }, [sortOrderStatus])

  const sortOrder = async (e) => {
    sortOrderStatusState(e.target.checked);
  }

  useEffect(() => {
    rfpService.getrfpByUser().then(
      res => {
        if (res) {
          // console.log(res, "res");
          setRfpCopyState(res.rfp);
          setRfpState(res.rfp);
        }
      }
    )

    getRfpByUserStart();

  }, [])


  const filterRfpApi = (e) => {
    rfpService.getrfpByUser(e.target.value).then(
      res => {
        if (res) {
          setRfpCopyState(res.rfp);
          setRfpState(res.rfp);
          sortOrderStatusState(false)
          filterValState('select');
        }
      }
    )
  }

  // console.log(products, "products2");
  console.log(productData, "productData");


  return (
    products?.length > 0 ?
      (
        <Page
          className={classes.root}
          title="Products"
        >
          <div id="rightContain">
            <Container maxWidth={false}>
              <Toolbar
                filterRfp={(e) => filterRfp(e)}
                sortRfp={(e) => sortRfp(e.target.value)}
                sortOrder={(e) => sortOrder(e)}
                filterRfpApi={filterRfpApi}
              />
              <Box mt={3}>
                <Grid
                  container
                  spacing={3}
                >
                  {products.map((product) => (
                    // <Grid
                    //   item
                    //   key={product.id}
                    //   lg={4}
                    //   md={6}
                    //   xs={12}
                    // >
                    <ProductCard
                      className={classes.productCard}
                      product={product}
                    />
                    // </Grid>
                  ))}
                </Grid>
              </Box>
              <Box
                mt={3}
                display="flex"
                justifyContent="center"
              >
                {/* <Pagination
            color="primary"
            count={3}
            size="small"
          /> */}
              </Box>
            </Container>
          </div>
        </Page>
      ) : (<Page
        className={classes.root}
        title="Products"
      >
        <div id="rightContain">
          <Container maxWidth={false}>
            <Toolbar
              filterRfp={(e) => filterRfp(e)}
              sortRfp={(e) => sortRfp(e.target.value)}
              sortOrder={(e) => sortOrder(e)}
              filterRfpApi={filterRfpApi}
            />
            <Box mt={3}>
              <Grid
                container
                spacing={3}
              >
                Please click the + button to create your first request
              </Grid>
            </Box>
            <Box
              mt={3}
              display="flex"
              justifyContent="center"
            >
              {/* <Pagination
          color="primary"
          count={3}
          size="small"
        /> */}
            </Box>
          </Container>
        </div>
      </Page>)
  )
};

const mapStateToProps = state => ({
  productData: state.product.productData.response,

});

const mapDispatchToProps = (dispatch) => ({
  getRfpByUserStart: (value) => dispatch(getRfpByUserStart(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
